import { DialogTitle } from '@mui/material';
import { hearingTypeLabel } from 'helpers/legacyHearingType';
import { BootstrapDialog } from 'components/subUsers/AddSubUsers';
import React, { useRef, useState } from 'react'
import { cdn } from 'constants/common';
import Api from 'services/api';
import toast from 'react-hot-toast';
import { downloadFileResponse } from 'helpers/downloadFileResponse';

const CaseDetailModal = ({ onClose, modalData, onRefresh }) => {
    const { open, data } = modalData;
    const [translatedFile, setTranslatedFile] = useState(null);
    const [translatedDocument, setTranslatedDocument] = useState(null);
    const fileInputRef = useRef(null);

    React.useEffect(() => {
        setTranslatedDocument(data?.translated_document || null);
    }, [data]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        // Preflight the 50MB cap so oversized files fail with a clear message before uploading
        if (file && file.size > 50 * 1024 * 1024) {
            toast.error(`This file is ${(file.size / (1024 * 1024)).toFixed(1)}MB — the limit is 50MB. Please compress the file and try again.`, { className: "errorToast" });
            e.target.value = "";
            setTranslatedFile(null);
            return;
        }
        setTranslatedFile(file);
    };

    const uploadTranslatedFile = async () => {
        try {

            if (!translatedFile) {
                alert("Please select a file");
                return;
            }

            const formData = new FormData();
            formData.append("translated_file", translatedFile);
            formData.append("case_id", data?.id);

            const response = await Api.uploadTranslatedFile(formData);

            if (response?.status === 200) {
                toast.success("File uploaded successfully");
                setTranslatedDocument(response.data?.translated_document || null);
                if (onRefresh) onRefresh();
                setTranslatedFile(null);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            }

        } catch (error) {
            console.log("Upload error", error);
            // The backend now explains size/type problems — show its message instead of failing silently
            toast.error(error?.response?.data?.message || "Upload failed. Please try again.", { className: "errorToast" });
        }
    };

    const downloadTranslation = async () => {
        try {
            const filePath = data?.translation_document;
            if (!filePath) return;

            const response = await Api.downloadTranslation(filePath);
            await downloadFileResponse(response, filePath.split("/").pop());
        } catch (error) {
            console.log("Download error", error);
            toast.error("Download failed.", { className: "errorToast" });
        }
    };

    const rowDash2Style = {
        display: 'block',
        alignItems: 'normal',
        width: '100%',
        gap: '1rem'
    };

    console.log(data, "data")
    return (
        <BootstrapDialog
            fullWidth={true}
            maxWidth={"lg"}
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <div className="">
                <div className="modal-content full_modal">
                    <DialogTitle>
                        <div className="modal-header header_modal align-items-center">
                            <div></div>
                            <h5 className="modal-title_u">Case Details</h5>
                            <button type="button" className="btn-close"
                                aria-label="Close"
                                onClick={() => onClose(data?.id, data?.status)}
                            ></button>
                        </div>
                    </DialogTitle>
                    <div className="modal-body modal_form_body">
                        <div className="row_dash_1" style={rowDash2Style}>
                            <div className="Table_data_show Table_data_show1 pt-0 ">
                                <table class="bg-primary-secondary table">
                                    <tbody>
                                        <tr>
                                            <td className="col-2">Case ID:</td>
                                            <td className="col-2 text-transform-capitalize">{data?.case_id || 'N/A'}</td>
                                            <td className='col-2'>Case Number:</td>
                                            <td className='col-2'>{data?.case_number || 'N/A'}</td>
                                            <td className='col-2'>Name:</td>
                                            <td className='col-2'>{data?.client_name || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Case Type:</td>
                                            <td>{data?.case_type?.name || 'N/A'}</td>
                                            <td>Hearing Type:</td>
                                            <td>{hearingTypeLabel(data, { tag: false })}</td>
                                            <td>Hearing min hour:</td>
                                            <td>{data?.hearing_type?.minimum_hours || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Party Type:</td>
                                            <td>{data?.party_type?.name || 'N/A'}</td>
                                            <td>Court Address:</td>
                                            <td colSpan={3}>{data?.court_address || 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Courtroom:</td>
                                            <td>{data?.courtroom?.name || 'N/A'}</td>
                                            <td>Courtroom Zoom link:</td>
                                            <td colSpan={3}>
                                                {data?.courtroom?.zoom_link &&
                                                    <a href={data?.courtroom?.zoom_link} target="_blank">
                                                        {data?.courtroom?.zoom_link}
                                                    </a>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Hearing time:</td>
                                            <td>{data?.hearing_start_time || 'N/A'}</td>
                                            <td>Created At:</td>
                                            <td>{data?.created_at ? new Date(data?.created_at).toLocaleString() : 'N/A'}</td>
                                            <td>Updated At:</td>
                                            <td>{data?.updated_at ? new Date(data?.updated_at).toLocaleString() : 'N/A'}</td>
                                        </tr>
                                        <tr>
                                            <td>Notes:</td>
                                            <td colSpan={5}>{data?.notes || 'N/A'}</td>
                                        </tr>

                                        {data?.translation_document && (
                                            <tr>
                                                <td>Translation File:</td>
                                                <td colSpan={5}>
                                                    {data?.translation_document ? (
                                                        <button
                                                            type="button"
                                                            className="main_button"
                                                            onClick={downloadTranslation}
                                                        >
                                                            Download File
                                                        </button>
                                                    ) : (
                                                        'No file uploaded'
                                                    )}
                                                </td>
                                            </tr>
                                        )}


                                        {translatedDocument && (
                                            <tr>
                                                <td>Translated File:</td>
                                                <td colSpan={5}>
                                                    <button
                                                        type="button"
                                                        className="main_button"
                                                        onClick={async () => {
                                                            try {
                                                                const response = await Api.downloadTranslation(translatedDocument);
                                                                await downloadFileResponse(response, translatedDocument.split("/").pop());
                                                            } catch (error) {
                                                                console.log("Download error", error);
                                                                toast.error("Download failed.", { className: "errorToast" });
                                                            }
                                                        }}
                                                    >
                                                        Download Translated File
                                                    </button>
                                                </td>
                                            </tr>
                                        )}

                                        {data?.translation_document &&(
                                        <tr>
                                            <td>Upload Translated File:</td>
                                            <td colSpan={5}>
                                                <div className="row-primary">

                                                    <input
                                                        type="file"
                                                        className="input-in type_inp"
                                                        style={{ paddingTop: '10px' }}
                                                        ref={fileInputRef}
                                                        onChange={handleFileChange}
                                                    />

                                                    <button
                                                        type="button"
                                                        className="main_button"
                                                        onClick={uploadTranslatedFile}
                                                        style={{ marginLeft: "10px" }}
                                                    >
                                                        Upload File
                                                    </button>

                                                </div>
                                            </td>
                                        </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </BootstrapDialog>
    )
}

export default CaseDetailModal
